import type { ModelThinkingEffort } from "../modelPicker/catalog";

export type AnthropicEffort = "low" | "medium" | "high" | "xhigh" | "max";

/**
 * Maps a picker reasoning effort onto Anthropic's `output_config.effort`.
 *
 * Effort scales every token in the response, tool calls included, not just
 * thinking. Claude has no `none` level, so a stale or OpenAI-only selection
 * floors to `low` instead of producing an invalid request.
 */
const EFFORT_BY_REASONING_EFFORT: Record<ModelThinkingEffort, AnthropicEffort> = {
  none: "low",
  low: "low",
  medium: "medium",
  high: "high",
  xhigh: "xhigh",
  max: "max",
};

export function toAnthropicEffort(effort: string | undefined): AnthropicEffort {
  return EFFORT_BY_REASONING_EFFORT[effort as ModelThinkingEffort] ?? "low";
}

/**
 * Adaptive thinking is the only thinking mode Claude 4.7+ accepts; manual
 * `{type:"enabled", budget_tokens}` is rejected with a 400. `display` defaults
 * to `"omitted"`, which leaves thinking blocks empty, so `"summarized"` keeps
 * parity with OpenAI's `reasoning.summary: "auto"`.
 */
export const ADAPTIVE_THINKING = { type: "adaptive", display: "summarized" } as const;
